// extracted by mini-css-extract-plugin
export default {"allReviews__content":"AllReviews_allReviews__content__MweGU","allReviews":"AllReviews_allReviews__0cFA3"};